module App.Interfaces {
    export interface IAddress  {
        street: string;
        houseNumber: string;
        postalCode: string;
        city: string;
        remark: string;
        salutation: string;
        firstName: string;
        middleName: string;
        lastName: string;
        phoneNumber: string;
        email: string;
    }
}